import classNames from "classnames/bind";
import React from "react";
import { Icon } from "../Icon";
import { Skeleton } from "../Skeleton";
import styles from "./Drawer.module.scss";
import { DrawerDescriptorWithIconProps } from "./types";

const cx = classNames.bind(styles);

const DrawerDescriptorWithIcon = ({
  isLoading,
  iconProps,
  title,
  titleHeader,
  titleFooter,
}: DrawerDescriptorWithIconProps) => {
  return (
    <div className={cx("descriptor")}>
      <Skeleton isLoading={isLoading}>
        <div
          className={`${cx("icon")} ${iconProps?.containerClassName ?? ""}`}
          style={iconProps?.containerStyle}
        >
          {iconProps && (
            <Icon
              variant={iconProps.variant}
              size={24}
            />
          )}
        </div>
      </Skeleton>
      <div className={cx("content")}>
        <div className={cx("information")}>
          {titleHeader && (
            <Skeleton
              isLoading={isLoading}
              style={{ minWidth: 100 }}
            >
              <p className={cx("titleHeader")}>{titleHeader}</p>
            </Skeleton>
          )}
          <div className={cx("titleContainer")}>
            {title && (
              <Skeleton
                isLoading={isLoading}
                style={{ minWidth: 200, minHeight: 35 }}
              >
                <p className={cx("title")}>{title}</p>
              </Skeleton>
            )}
          </div>
          {titleFooter && (
            <Skeleton
              isLoading={isLoading}
              style={{ minWidth: 100 }}
            >
              <p className={cx("titleFooter")}>{titleFooter}</p>
            </Skeleton>
          )}
        </div>
      </div>
    </div>
  );
};

export default DrawerDescriptorWithIcon;
